import { Component, EventEmitter, Input, Output, inject } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { AuthFacade, PetsFacade } from 'auth'
import { AppMenuPanelComponent } from '../app-menu-panel/app-menu-panel.component'

@Component({
  selector: 'ex-app-profile-menu',
  standalone: true,
  imports: [CommonModule, RouterModule, AppMenuPanelComponent],
  templateUrl: './app-profile-menu.component.html',
  styleUrls: ['./app-profile-menu.component.scss']
})
export class AppProfileMenuComponent {

  @Input() isOpen = false
  @Output() close = new EventEmitter<void>()

  #authFacade = inject(AuthFacade)
  #petsFacade = inject(PetsFacade)

  isAuthenticated = this.#authFacade.isAuthenticated
  profile = this.#authFacade.profile
  currentPet = this.#petsFacade.currentPet

  logout() {
    this.#authFacade.logout()
    this.close.emit()
  }

}
